(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sofa-ranges"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sofa-ranges')) {
    class SofaRanges extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;

        this.cards = Array.prototype.slice.call(this.grid.children);
        this.sortEl = this.querySelector('[data-sort]');
        this.results = this.querySelector('[data-results]');
        this.empty = this.querySelector('[data-empty]');
        this.active = this.querySelector('[data-active]');
        this.currency = this.dataset.currency || 'GBP';
        this.logic = this.dataset.pieceLogic || 'all';
        this.storageKey = 'sr-view-' + this.dataset.sectionId;

        this.bands = this.parseBands(this.dataset.bands);
        this.buildPriceOptions();
        this.bindEvents();
        this.initView();
        this.apply();
      }

      parseBands(str) {
        var points = (str || '').split(',')
          .map(function (s) { return Math.round(parseFloat(s) * 100); })
          .filter(function (n) { return n > 0; })
          .sort(function (a, b) { return a - b; });
        if (!points.length) return [];
        var bands = [[0, points[0]]];
        for (var i = 1; i < points.length; i++) bands.push([points[i - 1], points[i]]);
        bands.push([points[points.length - 1], null]);
        return bands;
      }

      money(p) {
        return (p / 100).toLocaleString('en-GB', { style: 'currency', currency: this.currency, maximumFractionDigits: 0 });
      }

      inBand(price, b) {
        return price >= b[0] && (b[1] === null || price < b[1]);
      }

      bandLabel(b) {
        if (b[0] === 0) return 'Under ' + this.money(b[1]);
        if (b[1] === null) return this.money(b[0]) + ' and over';
        return this.money(b[0]) + ' to ' + this.money(b[1]);
      }

      buildPriceOptions() {
        var box = this.querySelector('[data-price-options]');
        if (!box) return;
        var self = this;
        this.bands.forEach(function (b, i) {
          var n = self.cards.filter(function (c) { return self.inBand(Number(c.dataset.price), b); }).length;
          if (!n) return;
          var label = document.createElement('label');
          label.className = 'sr-opt';
          label.innerHTML = '<input type="checkbox" name="band" value="' + i + '"><span class="sr-opt__label">' + self.bandLabel(b) + '</span><span class="sr-opt__n">(' + n + ')</span>';
          box.appendChild(label);
        });
      }

      checked(name) {
        return Array.prototype.slice.call(this.querySelectorAll('input[name="' + name + '"]:checked'));
      }

      apply() {
        var self = this;
        var pieces = this.checked('piece').map(function (i) { return i.value; });
        var bands = this.checked('band').map(function (i) { return self.bands[Number(i.value)]; });
        var visible = 0;

        this.cards.forEach(function (c) {
          var has = function (p) { return c.dataset.pieces.indexOf('|' + p + '|') > -1; };
          var ok = !pieces.length || (self.logic === 'any' ? pieces.some(has) : pieces.every(has));
          if (ok && bands.length) ok = bands.some(function (b) { return self.inBand(Number(c.dataset.price), b); });
          c.hidden = !ok;
          if (ok) visible++;
        });

        var s = this.sortEl ? this.sortEl.value : 'name-asc';
        this.cards.slice().sort(function (a, b) {
          if (s === 'name-asc') return a.dataset.name.localeCompare(b.dataset.name);
          if (s === 'name-desc') return b.dataset.name.localeCompare(a.dataset.name);
          if (s === 'price-asc') return a.dataset.price - b.dataset.price;
          if (s === 'price-desc') return b.dataset.price - a.dataset.price;
          if (s === 'newest') return b.dataset.date - a.dataset.date;
          return 0;
        }).forEach(function (c) { self.grid.appendChild(c); });

        if (this.results) this.results.textContent = visible + (visible === 1 ? ' range' : ' ranges');
        if (this.empty) this.empty.hidden = visible > 0;

        var pc = this.querySelector('[data-count-for="piece"]');
        var bc = this.querySelector('[data-count-for="band"]');
        if (pc) pc.textContent = pieces.length || '';
        if (bc) bc.textContent = bands.length || '';

        this.renderPills();
      }

      renderPills() {
        var self = this;
        var on = this.checked('piece').concat(this.checked('band'));
        this.active.innerHTML = '';
        this.active.hidden = !on.length;
        on.forEach(function (input) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'sr__pill';
          pill.textContent = input.closest('label').querySelector('.sr-opt__label').textContent;
          pill.addEventListener('click', function () { input.checked = false; self.apply(); });
          self.active.appendChild(pill);
        });
        if (on.length) {
          var clear = document.createElement('button');
          clear.type = 'button';
          clear.className = 'sr__clear';
          clear.textContent = 'Clear all';
          clear.addEventListener('click', function () { self.clearAll(); });
          this.active.appendChild(clear);
        }
      }

      clearAll() {
        this.querySelectorAll('input[name="piece"], input[name="band"]').forEach(function (i) { i.checked = false; });
        this.apply();
      }

      setView(v, save) {
        this.grid.dataset.view = v;
        this.querySelectorAll('[data-view-btn]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.viewBtn === v ? 'true' : 'false');
        });
        if (save && this.dataset.rememberView === 'true') {
          try { localStorage.setItem(this.storageKey, v); } catch (e) {}
        }
      }

      initView() {
        var v = this.dataset.defaultView || 'grid';
        if (this.dataset.rememberView === 'true' && !window.Shopify?.designMode) {
          try { v = localStorage.getItem(this.storageKey) || v; } catch (e) {}
        }
        this.setView(v, false);
      }

      bindEvents() {
        var self = this;
        this.addEventListener('change', function (e) {
          if (e.target.matches('input[name="piece"], input[name="band"], [data-sort]')) self.apply();
        });
        this.querySelectorAll('[data-view-btn]').forEach(function (b) {
          b.addEventListener('click', function () { self.setView(b.dataset.viewBtn, true); });
        });
        var clear = this.querySelector('[data-clear]');
        if (clear) clear.addEventListener('click', function () { self.clearAll(); });

        var drops = this.querySelectorAll('.sr-drop');
        drops.forEach(function (d) {
          d.addEventListener('toggle', function () {
            if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
          });
        });
        document.addEventListener('click', function (e) {
          drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
        });
      }
    }
    customElements.define('sofa-ranges', SofaRanges);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["taskers-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taskers-header')) {
    class TaskersHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.stickyType = this.dataset.sticky || 'none';
        this.shrink = this.dataset.shrink === 'true' && this.stickyType !== 'none';
        this.transparent = this.dataset.transparent === 'true';
        this.solidOnScroll = this.dataset.solidScroll === 'true';
        this.solidOnHover = this.dataset.solidHover === 'true';
        this.lastY = window.scrollY;
        this.baseHeight = 0;
        this.preventHide = false;
        this.hovering = false;
        this.ticking = false;

        if (this.section && this.shrink) this.section.classList.add('tkh-shrink-on');

        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        };
        this.onResize = () => this.measure(true);
        this.refresh = this.refresh.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        // Hover detection for the transparent header (mouse only, so taps don't get stuck)
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hovering = true;
          this.refresh();
        });
        this.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hovering = false;
          this.refresh();
        });

        // Search pop-up (details), mega menu and drawer all report open/close here
        this.addEventListener('toggle', this.refresh, true);
        this.addEventListener('tkh:statechange', this.refresh);

        this.resizeObserver = new ResizeObserver(() => {
          const scrolled = this.section && this.section.classList.contains('tkh-scrolled');
          if (!scrolled || !this.shrink) {
            this.measure(false);
          } else {
            this.setLiveHeight();
          }
        });
        this.resizeObserver.observe(this);

        this.bindLabels();
        this.fixIcons();
        this.measure(false);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.cartObserver) this.cartObserver.disconnect();
        document.documentElement.classList.remove('tkh-scroll-lock');
      }

      template(name) {
        const tpl = this.querySelector('template[data-tkh-tpl="' + name + '"]');
        return tpl ? tpl.innerHTML : '';
      }

      // Keeps our icons in place: Dawn re-renders the cart icon after every add to cart
      fixIcons() {
        const search = this.querySelector('.header__icon--search');
        if (search && !search.querySelector('.tkh-ico')) {
          const wrappers = search.querySelectorAll('.svg-wrapper');
          if (wrappers[0]) wrappers[0].innerHTML = this.template('search');
          if (wrappers[1]) wrappers[1].innerHTML = this.template('close');
        }

        const bubble = this.querySelector('#cart-icon-bubble');
        if (!bubble) return;
        const swap = () => {
          const wrapper = bubble.querySelector('.svg-wrapper:not(.tkh-cart-ico)');
          if (!wrapper) return;
          wrapper.classList.add('tkh-cart-ico');
          wrapper.innerHTML = this.template('cart');
        };
        swap();
        this.cartObserver = new MutationObserver(swap);
        this.cartObserver.observe(bubble, { childList: true });
      }

      bindLabels() {
        this.querySelectorAll('[data-tkh-proxy]').forEach((label) => {
          label.addEventListener('click', (event) => {
            event.preventDefault();
            const item = label.closest('.tkh__icon-item');
            const target = item && item.querySelector(label.dataset.tkhProxy);
            if (target) target.click();
          });
        });
      }

      measure(allowWhileScrolled) {
        if (!this.section) return;
        const scrolled = this.section.classList.contains('tkh-scrolled');
        let base = this.offsetHeight;

        if (scrolled && this.shrink) {
          if (!allowWhileScrolled) return;
          this.section.classList.add('tkh-measuring');
          this.section.classList.remove('tkh-scrolled');
          base = this.offsetHeight;
          this.section.classList.add('tkh-scrolled');
          void this.offsetHeight;
          this.section.classList.remove('tkh-measuring');
        }

        this.baseHeight = base;
                this.section.style.setProperty('--tkh-base-h', base + 'px');
        if (this.transparent) document.documentElement.style.setProperty('--tkh-overlap', base + 'px');
        this.setLiveHeight();
      }

      setLiveHeight() {
        document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
      }

      openState() {
        return Boolean(this.querySelector('.hm--open, details[open], taskers-drawer.is-open'));
      }

      isBusy() {
        if (this.preventHide) return true;
        if (this.section.classList.contains('menu-open')) return true;
        return this.openState();
      }

      // Transparent only at the top of the page, with nothing hovered or open
      refresh() {
        if (!this.section) return;
        const drawerOpen = Boolean(this.querySelector('taskers-drawer.is-open'));
        this.section.classList.toggle('tkh-drawer-open', drawerOpen);
        if (!this.transparent) return;

        const atTop = window.scrollY <= 8;
        const clear =
          !this.openState() &&
          !(this.solidOnScroll && !atTop) &&
          !(this.solidOnHover && this.hovering);
        this.classList.toggle('tkh--clear', clear);
      }

      update() {
        if (!this.section) return;
        const y = Math.max(window.scrollY, 0);

        if (this.stickyType !== 'none') {
          this.section.classList.toggle('tkh-scrolled', y > 8);

          if (this.stickyType === 'scroll-up') {
            const delta = y - this.lastY;
            if (y <= this.baseHeight) {
              this.section.classList.remove('tkh-hidden');
            } else if (delta > 4 && !this.isBusy()) {
              this.section.classList.add('tkh-hidden');
            } else if (delta < -4) {
              this.section.classList.remove('tkh-hidden');
            }
          }
        }

        this.lastY = y;
        this.refresh();
      }
    }

    customElements.define('taskers-header', TaskersHeader);
  }

  if (!customElements.get('taskers-drawer')) {
    class TaskersDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.tkh-drawer__panel');
        this.current = 'root';
        this.toggles = Array.from(document.querySelectorAll('[aria-controls="' + this.id + '"]'));
        this.onKey = this.onKey.bind(this);

        this.toggles.forEach((toggle) => {
          toggle.addEventListener('click', (e) => {
            e.preventDefault();
            this.isOpen ? this.close() : this.open(toggle);
          });
        });
        this.querySelectorAll('[data-tkh-drawer-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.querySelectorAll('[data-tkh-open]').forEach((btn) => {
          btn.addEventListener('click', () => this.showView(btn.dataset.tkhOpen, btn));
        });
        this.querySelectorAll('[data-tkh-back]').forEach((btn) => btn.addEventListener('click', () => this.showView('root')));

        this.mobileQuery = window.matchMedia('(min-width: 990px)');
        this.onBreakpoint = () => {
          if (this.mobileQuery.matches && !this.closest('.tkh--drawer-desktop')) this.close(true);
        };
        this.mobileQuery.addEventListener('change', this.onBreakpoint);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.onBreakpoint);
      }

      get isOpen() {
        return this.classList.contains('is-open');
      }

      notify() {
        this.dispatchEvent(new CustomEvent('tkh:statechange', { bubbles: true }));
      }

      open(trigger) {
        this.lastTrigger = trigger;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        this.toggles.forEach((t) => t.setAttribute('aria-expanded', 'true'));
        document.documentElement.classList.add('tkh-scroll-lock');
        document.addEventListener('keydown', this.onKey);
        this.notify();
        setTimeout(() => {
          const close = this.querySelector('.tkh-drawer__close');
          if (close) close.focus({ preventScroll: true });
        }, 50);
      }

      close(silent) {
        if (!this.isOpen) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this.toggles.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        document.documentElement.classList.remove('tkh-scroll-lock');
        document.removeEventListener('keydown', this.onKey);
        this.notify();
        const reset = parseInt(getComputedStyle(this).getPropertyValue('--tkh-d-dur'), 10) || 300;
        setTimeout(() => this.showView('root', null, true), reset);
        if (!silent && this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
      }

      showView(name, opener, noFocus) {
        this.querySelectorAll('.tkh-drawer__view').forEach((view) => {
          const isRoot = view.dataset.view === 'root';
          if (isRoot) {
            view.classList.add('is-active');
            view.classList.toggle('is-behind', name !== 'root');
            view.toggleAttribute('inert', name !== 'root');
          } else {
            const active = view.dataset.view === name;
            view.classList.toggle('is-active', active);
            view.toggleAttribute('inert', !active);
          }
        });
        this.querySelectorAll('[data-tkh-open]').forEach((btn) => {
          btn.setAttribute('aria-expanded', btn.dataset.tkhOpen === name ? 'true' : 'false');
        });

        const previous = this.current;
        const views = this.querySelector('.tkh-drawer__views');
        if (views) views.scrollLeft = 0;
        this.current = name;
        if (noFocus) return;

        requestAnimationFrame(() => {
          if (name === 'root') {
            const back = this.querySelector('[data-tkh-open="' + previous + '"]');
            if (back) back.focus({ preventScroll: true });
          } else {
            const view = this.querySelector('[data-view="' + name + '"]');
            const target = view && view.querySelector('[data-tkh-back]');
            if (target) target.focus({ preventScroll: true });
            if (view) view.scrollTop = 0;
          }
        });
      }

      onKey(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          if (this.current !== 'root') {
            this.showView('root');
          } else {
            this.close();
          }
          return;
        }
        if (e.key !== 'Tab') return;

        const scope = this.querySelector('[data-view="' + this.current + '"]');
        const focusables = Array.from(
          this.querySelectorAll('.tkh-drawer__head a, .tkh-drawer__head button')
        ).concat(scope ? Array.from(scope.querySelectorAll('a[href], button:not([disabled])')) : []);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('taskers-drawer', TaskersDrawer);
  }

  if (!customElements.get('taskers-header-menu')) {
    class TaskersHeaderMenu extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.trigger || 'hover';
        this.openDelay = parseInt(this.dataset.openDelay || '0', 10);
        this.closeDelay = parseInt(this.dataset.closeDelay || '0', 10);
        this.items = Array.from(this.querySelectorAll('[data-mm-item]'));
        this.overlay = this.querySelector('[data-mm-overlay]');
        this.current = null;
        this.timer = null;
        this.pointerType = 'mouse';

        this.onDocClick = this.onDocClick.bind(this);
        this.onDocKey = this.onDocKey.bind(this);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onDocKey);

        if (this.overlay) this.overlay.addEventListener('click', () => this.close());

        this.items.forEach((item) => this.bindItem(item));

        if (window.Shopify && window.Shopify.designMode) this.initEditor();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onDocKey);
        if (this.editorHandlers) {
          Object.entries(this.editorHandlers).forEach(([name, fn]) => document.removeEventListener(name, fn));
        }
        clearTimeout(this.timer);
      }

      bindItem(item) {
        const trigger = item.querySelector('[data-mm-trigger]');
        if (!trigger) return;
        const isButton = trigger.tagName === 'BUTTON';

        item.addEventListener('pointerenter', (e) => {
          if (this.mode !== 'hover' || e.pointerType !== 'mouse') return;
          this.schedule(() => this.open(item), this.current ? 0 : this.openDelay);
        });

        item.addEventListener('pointerleave', (e) => {
          if (this.mode !== 'hover' || e.pointerType !== 'mouse') return;
          this.schedule(() => this.close(), this.closeDelay);
        });

        trigger.addEventListener('pointerdown', (e) => {
          this.pointerType = e.pointerType || 'mouse';
        });

        trigger.addEventListener('click', (e) => {
          const keyboard = e.detail === 0;
          const isOpen = this.current === item;

          if (this.mode === 'click' || isButton) {
            e.preventDefault();
            if (this.mode === 'hover' && !keyboard && this.pointerType === 'mouse' && isOpen) return;
            isOpen ? this.close() : this.open(item);
            return;
          }

          // Hover mode with a real link: first tap on touch opens, second tap follows the link
          if (this.pointerType !== 'mouse' && !keyboard && !isOpen) {
            e.preventDefault();
            this.open(item);
          }
          this.pointerType = 'mouse';
        });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.open(item);
            const first = item.querySelector('[data-mm-panel] a');
            if (first) requestAnimationFrame(() => first.focus());
          }
        });

        if (this.mode === 'hover') {
          trigger.addEventListener('focus', () => {
            if (trigger.matches(':focus-visible')) this.open(item);
          });
        }

        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget) && this.current === item) this.close();
        });
      }

      schedule(fn, delay) {
        clearTimeout(this.timer);
        if (delay > 0) {
          this.timer = setTimeout(fn, delay);
        } else {
          fn();
        }
      }

      open(item) {
        clearTimeout(this.timer);
        if (this.current === item) return;
        if (this.current) this.setState(this.current, false);
        this.setState(item, true);
        this.current = item;
        this.classList.add('hm--open');
        this.dispatchEvent(new CustomEvent('tkh:statechange', { bubbles: true }));
      }

      close() {
        clearTimeout(this.timer);
        if (!this.current) return;
        this.setState(this.current, false);
        this.current = null;
        this.classList.remove('hm--open');
        this.dispatchEvent(new CustomEvent('tkh:statechange', { bubbles: true }));
      }

      setState(item, open) {
        item.classList.toggle('is-open', open);
        const trigger = item.querySelector('[data-mm-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      onDocClick(e) {
        if (this.current && !this.contains(e.target)) this.close();
      }

      onDocKey(e) {
        if (e.key !== 'Escape' || !this.current) return;
        const trigger = this.current.querySelector('[data-mm-trigger]');
        this.close();
        if (trigger) trigger.focus();
      }

      initEditor() {
        const mine = (e) => e.detail && e.detail.sectionId === this.dataset.sectionId;
        const firstItem = () => this.items[0];

        this.editorHandlers = {
          'shopify:section:select': (e) => {
            if (mine(e) && this.dataset.preview === 'true' && firstItem()) this.open(firstItem());
          },
          'shopify:section:deselect': (e) => {
            if (mine(e)) this.close();
          },
          'shopify:block:select': (e) => {
            if (!mine(e)) return;
            const tile = this.querySelector('[data-mm-block="' + e.detail.blockId + '"]');
            const item = tile && tile.closest('[data-mm-item]');
            if (item) this.open(item);
          }
        };

        Object.entries(this.editorHandlers).forEach(([name, fn]) => document.addEventListener(name, fn));

        if (this.dataset.preview === 'true' && firstItem()) this.open(firstItem());
      }
    }

    customElements.define('taskers-header-menu', TaskersHeaderMenu);
  }

  } catch(e) { console.error(e); }
})();
})();
